var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.1315 0.150772H132.017V66.4794C132.017 83.4831 122.946 99.1957 108.221 107.698L66.0741 132.036L23.9275 107.698C9.20233 99.1957 0.1315 83.4831 0.1315 66.4794V0.150772Z",
    fill: "#FFDD2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3267 35.0611V55.6908C39.1477 52.5052 44.2768 50.3492 50.1412 50.3492H56.5142V74.3308C56.5142 80.7111 54.7807 86.2956 52.2086 89.3674H79.9299C77.3632 86.2925 75.6336 80.715 75.6336 74.343V50.3492H82.0069C87.8713 50.3492 93.0003 52.5052 95.8214 55.6908V35.0611H36.3267Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.763bea4ff4e67dd898121d4af4a09dbc.svg";
export { ForwardRef as ReactComponent };